import React from "react";

import { Skeleton } from "@performyard/py-components";

const LoadingRespondentListEntry = () => {
	return (
		<li aria-label="Loading response" className="border-b border-solid border-neutral-2">
			<div className="px-4 py-2">
				<div className="grid grid-cols-[24px_1fr] items-center gap-1">
					<Skeleton className="h-6 w-6 rounded-full" />
					<Skeleton className="h-4 w-full" />
				</div>
				<div className="mt-1 pl-7">
					<Skeleton className="h-3 w-40" />
				</div>
			</div>
		</li>
	);
};

export default LoadingRespondentListEntry;
